import { render } from "./simple-sku-detail.vue?vue&type=template&id=a21022aa&scoped=true&ts=true"
import script from "./simple-sku-detail.vue?vue&type=script&lang=tsx"
export * from "./simple-sku-detail.vue?vue&type=script&lang=tsx"

import "./simple-sku-detail.vue?vue&type=style&index=0&id=a21022aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21022aa"]])

export default __exports__